import { render, staticRenderFns } from "./AddDollar.vue?vue&type=template&id=65358562&"
import script from "./AddDollar.vue?vue&type=script&lang=js&"
export * from "./AddDollar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports